import { render, staticRenderFns } from "./serviceUsage.vue?vue&type=template&id=b578675e&scoped=true&"
import script from "./serviceUsage.vue?vue&type=script&lang=js&"
export * from "./serviceUsage.vue?vue&type=script&lang=js&"
import style0 from "./serviceUsage.vue?vue&type=style&index=0&id=b578675e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b578675e",
  null
  
)

export default component.exports